export default __webpack_public_path__ + "static/media/SHEL.4b4e7c01.png";